import React from 'react';
function SidebarSteps({ activeStep = 1, kycCompleted = false }) {
   return (
      <div className="ppt_top_steps">
         <span data-step="1" className={activeStep === 1 ? 'active' : ''}>
            <em>Sign up details</em>
         </span>
         <span data-step="2" className={activeStep === 2 ? 'active' : ''}>
            <em>Verify your email</em>
         </span>
         <span data-step="3" className={activeStep === 3 ? 'active' : ''}>
            <em>Setup your wallet</em>
         </span>
         <span
            data-step="4"
            className={
               kycCompleted
                  ? 'active complete'
                  : activeStep === 4
                     ? 'active false'
                     : ''
            }
         >
            <em>{kycCompleted ? 'KYC in review' : 'KYC Pending'}</em>
         </span>
      </div>
   );
}
export default SidebarSteps;